import type { TranslateDictionary } from './en.js';

export const Cs: TranslateDictionary = {
  'Start airplay': 'Spustit AirPlay',
  'Stop airplay': 'Zastavit AirPlay',
  Audio: 'Audio',
  Captions: 'Titulky',
  'Enable captions': 'Povolit titulky',
  'Disable captions': 'Zakázat titulky',
  'Start casting': 'Spustit přenos',
  'Stop casting': 'Zastavit přenos',
  'Casting to {device}': 'Odesílání do {device}',
  'Enter fullscreen mode': 'Přejít na celou obrazovku',
  'Exit fullscreen mode': 'Ukončit celou obrazovku',
  Mute: 'Ztlumit',
  Unmute: 'Zrušit ztlumení',
  'Enter picture in picture mode': 'Zapnout režim obraz v obraze',
  'Exit picture in picture mode': 'Vypnout režim obraz v obraze',
  Play: 'Přehrát',
  Pause: 'Pozastavit',
  'Playback rate': 'Rychlost přehrávání',
  'Playback rate {playbackRate}': 'Rychlost přehrávání {playbackRate}',
  Quality: 'Kvalita',
  'Seek backward': 'Převinout vzad',
  'Seek forward': 'Převinout vpřed',
  Settings: 'Nastavení',
  Auto: 'Auto',
  'audio player': 'audio přehrávač',
  'video player': 'video přehrávač',
  volume: 'Hlasitost',
  seek: 'Hledat',
  'closed captions': 'Titulky',
  'current playback rate': 'aktuální rychlost přehrávání',
  'playback time': 'čas přehrávání',
  'media loading': 'načítání médií',
  settings: 'Nastavení',
  'audio tracks': 'audiostopy',
  quality: 'Kvalita',
  play: 'přehrát',
  pause: 'pozastavit',
  mute: 'ztlumit',
  unmute: 'zrušit ztlumení',
  'chapter: {chapterName}': 'kapitola: {chapterName}',
  live: 'živě',
  Off: 'Vypnuto',
  'start airplay': 'spustit AirPlay',
  'stop airplay': 'zastavit AirPlay',
  'start casting': 'spustit přenos',
  'stop casting': 'zastavit přenos',
  'enter fullscreen mode': 'přejít na celou obrazovku',
  'exit fullscreen mode': 'ukončit celou obrazovku',
  'enter picture in picture mode': 'zapnout režim obraz v obraze',
  'exit picture in picture mode': 'vypnout režim obraz v obraze',
  'seek to live': 'přejít na živé vysílání',
  'playing live': 'přehrávání živě',
  'seek back {seekOffset} seconds': 'převinout vzad o {seekOffset} s',
  'seek forward {seekOffset} seconds': 'převinout vpřed o {seekOffset} s',
  'Network Error': 'Chyba sítě',
  'Decode Error': 'Chyba dekódování',
  'Source Not Supported': 'Zdroj není podporován',
  'Encryption Error': 'Chyba šifrování',
  'A network error caused the media download to fail.':
    'Chyba sítě způsobila selhání stahování médií.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Chyba médií způsobila přerušení přehrávání. Média mohou být poškozena nebo váš prohlížeč nepodporuje tento formát.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Došlo k nepodporované chybě. Server nebo síť selhaly, nebo váš prohlížeč nepodporuje tento formát.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Média jsou šifrována a neexistují žádné klíče k jejich dešifrování.',
  'This video is not available.': 'Toto video není k dispozici.',
  'This video could not be found.': 'Toto video se nepodařilo najít.',
};
